// extracted by mini-css-extract-plugin
export default {"imageContainer":"L--z","summaryPar":"M--z","ratingCategories":"N--z","reviewerInfo":"O--z","reviewTypes":"P--z","expanded":"Q--z"};